import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule,Injectable } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {HttpModule, Http, XHRBackend, RequestOptions} from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import {Routes, RouterModule} from "@angular/router";
import {MainModule} from "./main/main.module";
import {AuthGuardLogin, ModuleAccessGuard} from "./guards/auth.guard";
import {AuthGuardMain} from "./guards/auth.guard";
import {CommonService} from "./common/common.service";
import {AuthModule} from "./auth/auth.module";
import {HttpClientService} from "./common/http-client.service";
import {ToastService} from "./common/toast.service";
import {ToastrModule} from "ngx-toastr";
import 'hammerjs';
import {InterceptedHttp} from "./common/intercepted-http.service";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { Ng2Webstorage } from 'ngx-webstorage';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { CustomLocationStrategy } from './common/custom-location-strategy';
import { FileUploadService } from './common/file-upload.service';
import { ProgressEventService } from './common/http/progress-event.service';
import { CustomBrowserXhrService } from './common/http/custom-browser-xhr.service';
import { CookieModule,CookieService } from './common/cookies';
import {CanDeactivateGuard} from "./guards";
import { AuthService } from './auth/auth.service';
import { UserRolesService } from './common/user-roles.service';
import {AccessProvider} from './access-provider';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { SharedModule } from './common/shared.module';
import { ActivationLinkComponent } from './auth/login/activation-link/activation-link.component';
import { LoginService } from './auth/login/login.service';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { PrivacyPolicyService } from './privacy-policy/privacy-policy.service';
import { TermsConditionsService } from './terms-conditions/terms-conditions.service';
export function HttpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, common: CommonService): Http {
  return new InterceptedHttp(xhrBackend, requestOptions, common);
}

const router:Routes = [
  {path: '', redirectTo: '/auth/login', pathMatch: 'full'},
  {path: 'activationlink', component: ActivationLinkComponent, canActivate: []},
  {path: 'privacy-policy', component: PrivacyPolicyComponent, canActivate: []},
  {path: 'terms-conditions', component: TermsConditionsComponent, canActivate: []},
  {path: '**', redirectTo: '/auth/login'}
];

export function accessProviderFactory(provider: AccessProvider) {
  return () => provider.load();
}

@NgModule({
  declarations: [
    AppComponent,
    ActivationLinkComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    AuthModule,
    MainModule,
    SharedModule,
    CookieModule.forRoot(),
    ToastrModule.forRoot({maxOpened:1,timeOut:10000,autoDismiss:true}), // ToastrModule added
    RouterModule.forRoot(router),
    NgbModule.forRoot(),
    Ng2Webstorage,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    })
  ],
  providers: [
    AccessProvider,
    { provide: APP_INITIALIZER, useFactory: accessProviderFactory, deps: [AccessProvider], multi: true },
    CommonService,
    HttpClientService,
    ModuleAccessGuard,
    CanDeactivateGuard,
    AuthGuardLogin,
    AuthGuardMain,
    ToastService,
    FileUploadService,
    ProgressEventService,
    CookieService,
    CustomBrowserXhrService,
    UserRolesService,
    {
           provide: Http,
           useFactory: HttpFactory,
           deps: [XHRBackend, RequestOptions,CommonService]
       },
    {provide: LocationStrategy, useClass: CustomLocationStrategy},
    AuthService,
    LoginService,
    PrivacyPolicyService,
    TermsConditionsService
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/app.module.ts